var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small"},[_c('line-chart',{staticStyle:{"background":"#19365A","padding":"7px","color":"#fff"},attrs:{"height":300,"chart-data":_vm.CHARTDATA,"dark":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }